<ul class="pnl-details-container">
  @if (parking.carPark.name) {
    <li>
      <span class="light-fat" i18n="@@parkingdetails_name">Name:</span>
      <span [innerHTML]="parking.carPark.name"></span>
    </li>
  }
  @if (parking.carPark.telephone) {
    <li>
      <span class="light-fat" i18n="@@parkingdetails_telephone">Telephone:</span>
      <span [innerHTML]="parking.carPark.telephone"></span>
    </li>
  }
  @if (parking.carPark.longitude || parking.carPark.latitude) {
    <li>
      <span class="light-fat" i18n="@@parkingdetails_geo">Geo-position:</span>
      <span>{{ parking.carPark.latitude }} {{ parking.carPark.longitude }}</span>
    </li>
  }
  @if (parking.carPark.introduction) {
    <li>
      <span class="light-fat" i18n="@@parkingdetails_intro">Introduction:</span>
      <span [innerHTML]="parking.carPark.introduction"></span>
    </li>
  }
  @if (parking.carPark.arrivalProcedure) {
    <li>
      <span class="light-fat" i18n="@@parkingdetails_arrival">Arrival Procedures:</span>
      <span [innerHTML]="parking.carPark.arrivalProcedure"></span>
    </li>
  }
  @if (parking.carPark.departureProcedure) {
    <li>
      <span class="light-fat" i18n="@@parkingdetails_depart">Departure Procedure:</span>
      <span [innerHTML]="parking.carPark.name"></span>
    </li>
  }
  @if (parking.carPark.information) {
    <li>
      <span class="light-fat" i18n="@@parkingdetails_info">Information:</span>
      <span [innerHTML]="parking.carPark.information"></span>
    </li>
  }
  @if (parking.carPark.misc.covidCopy) {
    <li>
      <span class="light-fat" i18n="@@parkingdetails_covid">Covid Information:</span>
      <span [innerHTML]="parking.carPark.misc.covidCopy"></span>
    </li>
  }
  @if (parking.carPark.misc.address) {
    <li>
      <span class="light-fat" i18n="@@parkingdetails_address">Address:</span>
      <span [innerHTML]="parking.carPark.address"></span>
    </li>
  }
  @if (parking.misc.cancellationFeeExceptions) {
    <li>
      <span class="light-fat" i18n="@@parkingdetails_cancellation">Cancellation Policy:</span>
      <span [innerHTML]="parking.carPark.address"></span>
    </li>
  }
</ul>
